import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DefaultNavBar from "components/Navbars/DefaultNavBar.js";
import LegalHeader from "components/Headers/LegalHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import SmsOptInForm from "components/Forms/SmsOptInForm.js";

function TextUpdatesPage(props) {
  React.useEffect(() => {
    document.body.classList.add("legal-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("legal-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <DefaultNavBar {...props} />
      <div className="wrapper">
        <LegalHeader title="Text Updates" />
        <div className="section">
          <Container className="legal-content">
            <Row className="justify-content-center">
              <Col md="8" lg="6">
                <h3>Employee Text Message Updates</h3>
                <p>
                  Unlimited Transportation employees can sign up here to receive
                  text messages about their dispatch and delivery assignments,
                  such as pickup ETAs, delivery confirmations, and requests for
                  delivery in and out times.
                </p>
                <SmsOptInForm />
                <p className="mt-5">
                  Questions? Call <a href="tel:614-351-0400">(614) 351-0400</a> or
                  email <a href="mailto:info@unlimitedtransportation.com">info@unlimitedtransportation.com</a>.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default TextUpdatesPage;
